/** Legacy single-tenant cart key (migrated once a store context is known). */
export const LEGACY_CART_KEY = "fastsell_cart";

export function cartStorageKey(storeId: string | undefined | null): string {
  if (!storeId) return LEGACY_CART_KEY;
  return `fastsell_cart_${storeId}`;
}

/** Funnel / analytics session id in localStorage (per store). */
export function funnelSessionStorageKey(storeId: string | undefined | null): string {
  if (!storeId) return "fastsell_session_id";
  return `fastsell_session_id_${storeId}`;
}

export function couponStorageKey(storeId: string | undefined | null, storeSlug?: string | null): string {
  if (storeId) return `fastsell_coupon_${storeId}`;
  if (storeSlug) return `fastsell_coupon_slug_${storeSlug}`;
  return "fastsell_coupon";
}

/**
 * Copy legacy global cart into scoped key once, then remove legacy (avoids cross-store bleed).
 */
export function migrateLegacyCartToStore(storeId: string): void {
  if (typeof localStorage === "undefined") return;
  try {
    const scoped = cartStorageKey(storeId);
    if (localStorage.getItem(scoped)) return;
    const legacy = localStorage.getItem(LEGACY_CART_KEY);
    if (!legacy || legacy === "[]") return;
    localStorage.setItem(scoped, legacy);
    localStorage.removeItem(LEGACY_CART_KEY);
  } catch {
    /* quota / private mode */
  }
}
